export default __webpack_public_path__ + "static/Avenir-Heavy-f728da1ab92fe217cfca730633ec44b0.ttf";